import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    TogglePageStatus as TogglePageStatusMutation,
    TogglePageStatusVariables as TogglePageStatusMutationVariables,
    SupportPageStatusToggleInput,
} from 'nutshell-graphql-types';

import TOGGLE_PAGE_STATUS from '../mutations/toggle-page-status.graphql';

export function useTogglePageStatus(): {
    togglePageStatus: (arg1: SupportPageStatusToggleInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [pageUpdate, {loading: isLoading, error}] = useMutation<
        TogglePageStatusMutation,
        TogglePageStatusMutationVariables
    >(TOGGLE_PAGE_STATUS);

    return {
        togglePageStatus: (input: SupportPageStatusToggleInput) =>
            pageUpdate({
                variables: {input},
            }),
        isLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
